
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface PuttingScoreButtonsProps {
  scoring: {
    condition: string;
    points: number;
  }[];
  onScoreSelect: (points: number) => void;
  isTestComplete: boolean;
}

const PuttingScoreButtons = ({ scoring, onScoreSelect, isTestComplete }: PuttingScoreButtonsProps) => {
  const { t } = useTranslation('common');
  
  // Map French conditions to translation keys
  const conditionMap: Record<string, string> = {
    "Balle rentrée": "puttingTraining.scoring.ballInLongPutts",
    "Balle à moins de 1m": "puttingTraining.scoring.ballLessThan1m",
    "Balle entre 1m et 2m": "puttingTraining.scoring.ballBetween1and2m",
    "Balle au-delà de 2m": "puttingTraining.scoring.ballBeyond2m",
    "Balle au-delà de 1m": "puttingTraining.scoring.ballBeyond1m",
    "Balle non rentrée": "puttingTraining.scoring.ballNotIn",
  };
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-3 mb-4">
      {scoring.map((score) => {
        const translationKey = conditionMap[score.condition];
        const translatedCondition = translationKey ? t(translationKey) : score.condition;
        
        const pointsLabel = Math.abs(score.points) <= 1 ? 'pt' : 'pts';
        
        return (
          <Button
            key={score.points}
            onClick={() => onScoreSelect(score.points)}
            className={`h-14 text-base font-medium ${
              score.points > 0 
                ? "bg-green-500 hover:bg-green-600 text-white border-0" 
                : "bg-red-500 hover:bg-red-600 text-white border-0"
            }`}
            disabled={isTestComplete}
          >
            {translatedCondition} ({score.points}{pointsLabel})
          </Button>
        );
      })}
    </div>
  );
};

export default PuttingScoreButtons;
